import React from 'react';
import { AlertTriangle, Clock } from 'lucide-react';

export default function MaintenancePage() {
  return (
    <div className="min-h-screen app-bg text-white flex flex-col items-center justify-center p-4">
      <div className="glass max-w-lg w-full rounded-3xl border border-navy-700/50 p-8 sm:p-12 text-center animate-pulse-slow relative overflow-hidden">
        {/* Dekoratif Arka Plan Işıkları */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-gradient-to-b from-orange-500/10 to-transparent blur-3xl pointer-events-none" />
        
        <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto bg-gradient-to-br from-orange-500/20 to-red-500/20 rounded-full flex items-center justify-center mb-8 relative">
           <div className="absolute inset-0 border-2 border-orange-500/30 rounded-full animate-ping opacity-50" style={{ animationDuration: '3s' }} />
           <AlertTriangle className="w-12 h-12 sm:w-16 sm:h-16 text-orange-400 drop-shadow-lg" />
        </div>
        
        <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-orange-300 to-red-400 bg-clip-text text-transparent mb-4">
          Sistem Bakımda
        </h1>
        
        <p className="text-navy-300 text-sm sm:text-base leading-relaxed mb-8">
          Size daha iyi hizmet verebilmek için Hasımoğlu Kurban Platformu üzerinde anlık bir teknik güncelleme gerçekleştiriyoruz. Lütfen kısa bir süre sonra tekrar deneyin.
        </p>

        <div className="flex items-center justify-center gap-3 text-xs sm:text-sm text-navy-400 bg-navy-900/50 p-4 rounded-xl border border-navy-700/50">
           <Clock className="w-4 h-4 text-gold-400" />
           <span>Anlayışınız için teşekkür ederiz.</span>
        </div>
      </div>
    </div>
  );
}
